import React, { Fragment, useState } from "react";

import Plotly from "plotly.js-dist";
import createPlotlyComponent from "react-plotly.js/factory";

const PlotView = (props) => {
  const Plot = createPlotlyComponent(Plotly);
  const [loading, setLoading] = useState(false);

  let fullEkgTemp = props.blob; ///fetching blob
  let sampling = props.sampling;
  let fullEkg = []; ///new array (need be shifted)

  let space = []; ///shift array
  for (var i = 0; i < 200; i++) {
    space.push(null);
  }

  for (var i = 0; i < space.length; i++) {
    ///combined shift and blob array together
    fullEkg.push(space[i]);
  }
  for (var i = 0; i < fullEkgTemp.length; i++) {
    fullEkg.push(fullEkgTemp[i]);
  }

  ////slice into three arrays. Each +-10 seconds
  let firstY = fullEkg.slice(0, fullEkg.length / 3); ///0 - 33%
  let secondY = fullEkg.slice(fullEkg.length / 3, (fullEkg.length * 2) / 3); ///34% - 66%;
  let thirdY = fullEkg.slice((fullEkg.length * 2) / 3, fullEkg.length); ///66 - 100%;

  ///geting how many x values there are and multiplies by sampling
  let data = [];
  for (var i = 0; i < fullEkg.length; i++) {
    data.push(i * (1 / sampling));
  }

  ////slice into three arrays. Each +-10 seconds
  let firstX = data.slice(0, data.length / 3); ///0 - 33%
  let secondX = data.slice(data.length / 3, (data.length * 2) / 3); ///34% - 66%;
  let thirdX = data.slice((data.length * 2) / 3, data.length); ///66 - 100%;

  ///ecg scale
  let scale = [];
  for (var i = 0; i < firstX.length; i++) {
    scale.push(null);
  }

  //ecg scale
  let scale2 = [];
  for (var i = 0; i < secondX.length; i++) {
    scale2.push(null);
  }

  //ecg scale
  let scale3 = [];
  for (var i = 0; i < thirdX.length; i++) {
    scale3.push(null);
  }

  ///ecg frature
  let squareX = [];
  let squareY = [];
  for (var i = 0; i < firstX.length; i++) {
    squareX.push(firstX[i]);

    if (firstX[i] >= 0.04 && firstX[i] < 0.12) {
      squareY.push(0.1);
    } else if (firstX[i] == 0.12) {
      squareY.push(1.1);
    } else if (firstX[i] > 0.12 && firstX[i] < 0.32) {
      squareY.push(1.1);
    } else if (firstX[i] == 0.32) {
      squareY.push(0.1);
    } else if (firstX[i] > 0.32 && firstX[i] < 0.4) {
      squareY.push(0.1);
    } else if (firstX[i] > 0.4) {
      break;
    } else {
      squareY.push(null);
    }
  }

  ///making plots
  //feature
  var squere = {
    x: firstX,
    y: squareY,
    type: "scatter",
    marker: { color: "red" },
    name: "Cecha",
  };

  //main plots
  var ekg = {
    y: firstY,
    x: firstX,
    type: "scattergl",
    marker: { color: "black" },
    name: "EKG",
  };

  var ekg2 = {
    y: secondY,
    x: secondX,
    type: "scatter",
    marker: { color: "black" },
    name: "EKG",
  };

  var ekg3 = {
    y: thirdY,
    x: thirdX,
    type: "scatter",
    marker: { color: "black" },
    name: "EKG",
  };

  ///scale plots
  var ekgScale = {
    x: firstX,
    y: scale,
    type: "scattergl",
    marker: { color: "red" },
    yaxis: "y2",
    xaxis: "x2",
  };

  var ekgScale2 = {
    x: secondX,
    y: scale,
    type: "scattergl",
    marker: { color: "red" },
    yaxis: "y2",
    xaxis: "x2",
  };

  var ekgScale3 = {
    x: thirdX,
    y: scale,
    type: "scattergl",
    marker: { color: "red" },
    yaxis: "y2",
    xaxis: "x2",
  };

  ///layout settings
  var layout = {
    width: 3000,
    height: 485,
    showlegend: false,
    plot_bgcolor: "white",
    paper_bgcolor: "rgba(128, 128, 128, 0.658);",
    xaxis: {
      autotick: false,
      tick0: 0,
      dtick: 0.04,
      ticks: "",
      gridcolor: "#e0a19d",
      tickcolor: "#000",
      showticklabels: false,
    },
    yaxis: {
      autotick: false,
      tick0: 0,
      dtick: 0.1,
      ticks: "",
      tickcolor: "#000",
      gridcolor: "#e0a19d",
      range: [-1.5, 1.5],
      showticklabels: false,
    },

    yaxis2: {
      gridwidth: 1.5,
      overlaying: "y",
      tick0: 0,
      dtick: 0.5,
      gridcolor: "#e0a19d",
      range: [-1.5, 1.5],
      ticks: "s",
    },

    xaxis2: {
      gridwidth: 1.5,
      tick0: 0,
      dtick: 0.2,
      showgrid: true,
      gridcolor: "#e0a19d",
      overlaying: "x",
      ticks: "s",
    },
  };

  var config = {
    displayModeBar: false,
  };

  if (loading == true) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div>
        <div className="scrollbox_side">
          <div className="examination_side">
            <div className="plot_count">
              <h5>Wykres 1/3 (1-10s)</h5> <h5>Przesuw 25mm/s</h5>
            </div>
            <Plot
              data={[ekg, ekgScale, squere]}
              layout={layout}
              config={config}
            />
            {/* <div className="plot_pass"><h5>Przesuw 25mm/s</h5></div>  */}
          </div>
        </div>
      </div>

      <div>
        <div className="scrollbox_side">
          <div className="examination_side">
            <div className="plot_count">
              <h5>Wykres 2/3 (10-20s)</h5> <h5>Przesuw 25mm/s</h5>
            </div>
            <Plot data={[ekg2, ekgScale2]} layout={layout} config={config} />
            {/* <div className="plot_pass"><h5>Przesuw 25mm/s</h5></div>  */}
          </div>
        </div>
      </div>
      <div>
        <div className="scrollbox_side">
          <div className="examination_side">
            <div className="plot_count">
              <h5>Wykres 3/3 (20-30s)</h5> <h5>Przesuw 25mm/s</h5>
            </div>
            <Plot data={[ekg3, ekgScale3]} layout={layout} config={config} />
            {/* <div className="plot_pass"><h5>Przesuw 25mm/s</h5></div>  */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlotView;
